import React from 'react';

import styles from '../styles.module.scss';
import encryptedStyles from './Encrypted.module.scss';
import {Encrypted, EncryptedHover} from '../../../assets';

export const EncryptedCard = () => {
  return (
    <div className={encryptedStyles.encrypted}>
      <div className={styles.label}>
        <div className={styles.labelInner}>SECURITY</div>
      </div>
      <h4 className={styles.title}>End-to-end encrypted</h4>
      <p className={styles.subTitle}>
        Because of advanced cryptography, no one else - not even us - can read your data.
      </p>
      <div className={encryptedStyles.decor}>
        <Encrypted />
      </div>
      <div className={encryptedStyles.hover}>
        <EncryptedHover />
      </div>
    </div>
  );
};
